import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/cloud-app.mp4'; 
import DatacenterImage2 from '../../../assets/images/itmonkeys-cyber-landing.jpeg';
import SecurityImg from '../../../assets/images/itmonkeys-cyber-img.jpeg';
import NasSynologyImage from '../../../assets/images/app-cloud.jpeg';
import CorporateImage from '../../../assets/images/app-cloud.jpeg'
import ShinyButton from '../../Common/ShinyButton/ShinyButton';
import ShinyContactButton from '../../Common/ContactComponent/ShinyContactButton';
import ContactComponent from '../../HomePage/ContactSectionHome/ContactSectionHome'; 
import { AnimatedGridPattern } from '../../ui/animated-grid-pattern';
import { cn } from "../../../lib/utils";
import { appCloudFeatures } from '../../../data/features';
import { FeaturesSectionWithHoverEffects } from '../../ui/feature-section-with-hoover-effect';
import CloudArchitectureImg from '../../../assets/images/logo-landing-itmonkeys-grey.png';

const IntroSectionAppCloud: React.FC = () => {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleOpenContactModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

    return (
    <div className="intro-section-migration">
      <div className="container-max-width tw-relative tw-flex tw-h-[500px] tw-w-full tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-border tw-bg-background tw-md:pt-20 tw-md:shadow-xl tw-mb-[3em]">
      <div className="centered-title-top">
      <div className="title-image-container">
        <img src={CloudArchitectureImg} alt={t('appCloud.introSection.architectureAlt', 'Architecture Cloud')} className="title-below-image overflow-visible" />
      </div>
      <h2>{t('appCloud.introSection.accelerateTitle', 'Accélérez vos déploiements')}</h2>
      <h3>{t('appCloud.introSection.accelerateSubtitle', 'Déployez des fonctionnalités et testez des innovations en temps réel pour adapter votre offre à votre demande. Les déploiements applicatifs sont maintenant rapides, faciles et sans contraintes physiques.')}</h3>
      </div>
      <div className="tw-w-full tw-flex tw-flex-col tw-mt-8 tw-mt-[-8em]">
        <div className="tw-w-full tw-px-4 tw-mt-[3em]">
          <FeaturesSectionWithHoverEffects 
            limit={4} 
            displayInRow={true} 
            featuresData={appCloudFeatures}
          />
        </div>
      </div>
    
      <AnimatedGridPattern
        numSquares={30}
        maxOpacity={0.1}
        duration={3}
        repeatDelay={1}
        className={cn(
          "[mask-image:radial-gradient(500px_circle_at_center,white,transparent)]",
          "tw-inset-x-0 tw-inset-y-[-30%] tw-h-[200%] tw-skew-y-12",
        )}
      />
    </div>
    <div className="intro-section">
      <div className="intro-row-1">
        <div className="intro-text-1">
          <h2 className='blue-h2'>{t('appCloud.introSection.row1.title', 'Une orchestration fluide')}</h2>
          <p className="subtitle">{t('appCloud.introSection.row1.subtitle', 'Du devéloppement à la production.')}</p>
          <h3>{t('appCloud.introSection.row1.description', 'IT Monkeys est là pour vous aider à orchestrer vos déploiements de manière efficace et sécurisée, pour que vous puissiez rester focalisé sur la croissance et l\'amélioration de vos applications.')}</h3>
        </div>
        <div className="intro-image">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            style={{position: 'absolute', bottom: 0, left: 0, width: '100%', borderTopLeftRadius: '100px', }}
          >
            <source src={ItmonkeysVideo} type="video/mp4" />
            {t('appCloud.introSection.videoFallback', 'Votre navigateur ne supporte pas la balise vidéo.')}
          </video>
        </div>
      </div>

      <div className="intro-row-2">
        <div className="intro-text-2">
          <h2 className='blue-h2'>{t('appCloud.introSection.row2.title', 'Innovez sans contraintes')}</h2>
          
          <p className="subtitle">{t('appCloud.introSection.row2.subtitle', 'Depuis votre architecture cloud.')}</p>

          <h3>
          {t('appCloud.introSection.row2.description', 'Déployez votre application sans contraintes physiques et concentrez-vous sur ce qui compte vraiment : créer des applications exceptionnelles.')}</h3>
        </div>


        <div className="intro-image">
          <img src={CorporateImage} alt={t('appCloud.introSection.row2.imageAlt', 'Security')} />
        </div>
      </div>

      <div className="intro-row-3">
        <div className="intro-text-3">
          <h2 className='blue-h2'>{t('appCloud.introSection.row3.title', 'Une technologie adaptée à vos besoins.')}</h2>
          <br></br>
          <h3>{t('appCloud.introSection.row3.description', 'Contrairement à un serveur traditionnel, le NAS est principalement focalisé sur la fonction de stockage, avec une interface de gestion souvent plus simple et des fonctionnalités préintégrées pour la sauvegarde, le partage, la sécurité et la synchronisation des données.')}</h3>
        </div>
        <div className="intro-image-3">
          <img src={NasSynologyImage} alt={t('appCloud.introSection.row3.imageAlt', 'Azure OpenAI')} />
        </div>
      </div>
    </div>
    </div>
  );
};

export default IntroSectionAppCloud;
